import { Dispatch } from 'redux';

import { get, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import CustomAppTypes from '../config/customAppTypes';
import { AppState } from '../reducers';
import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;
export type FetchCardsResponse = import('../generated-types').KortResponse;

export interface FetchCardsStartedAction extends Action<typeof actionTypes.FETCH_CARDS_STARTED> {
    type: typeof actionTypes.FETCH_CARDS_STARTED;
}

export interface FetchCardsFulfilledAction extends Action<typeof actionTypes.FETCH_CARDS_FULFILLED> {
    type: typeof actionTypes.FETCH_CARDS_FULFILLED;
    payload: FetchCardsResponse;
}

export interface FetchCardsFailedAction extends Action<typeof actionTypes.FETCH_CARDS_FAILED> {
    type: typeof actionTypes.FETCH_CARDS_FAILED;
    payload: RequestExceptionWithResponse;
}

export type CardsActions = FetchCardsStartedAction | FetchCardsFulfilledAction | FetchCardsFailedAction;

export const fetchCardsStarted = (): FetchCardsStartedAction => ({
    type: actionTypes.FETCH_CARDS_STARTED,
});
export const fetchCardsFulfilled = (json: FetchCardsResponse): FetchCardsFulfilledAction => ({
    type: actionTypes.FETCH_CARDS_FULFILLED,
    payload: json,
});
export const fetchCardsFailed = (error: RequestExceptionWithResponse): FetchCardsFailedAction => ({
    type: actionTypes.FETCH_CARDS_FAILED,
    payload: error,
});

export const fetchCards = async (
    dispatch: Dispatch<AppActions>,
    getState: () => AppState,
): Promise<FetchCardsResponse | null> => {
    const { loader, context, lbs } = getState();
    const { hasFetchedCards, isFetchingCards } = loader;
    if (!hasFetchedCards && !isFetchingCards) {
        try {
            dispatch(fetchCardsStarted());
            const response: FetchCardsResponse = await get(
                `${actionTypes.RESOURCE_PATH}/kort/${
                    CustomAppTypes.isLbs(context) && lbs.lbsBankregnr ? lbs.lbsBankregnr : context.config.bankregnr
                }`,
                getRequestHeaders(context.config.bankregnr),
            );

            dispatch(fetchCardsFulfilled(response));
            return response;
        } catch (error) {
            dispatch(fetchCardsFailed(error));
        }
    }
    return null;
};
